import Dropdown from "../Dropdown";

interface DocumentPagesFilters {
  classification: string | null;
}

export default function ClassificationFilter({
  filters,
  handleClassificationChange,
  categories,
  categoriesWithGroups,
}: {
  filters: DocumentPagesFilters;
  handleClassificationChange: (value: string) => void;
  categories?: Array<{ label: string; value: string; disabled?: boolean }>;
  categoriesWithGroups?: Array<{
    label: string;
    options: Array<{ label: string; value: string; disabled?: boolean }>;
  }>;
}) {
  return (
    <>
      {/* Classification Filter */}
      <div className="flex flex-col gap-2 justify-between">
        <label
          htmlFor="classification"
          className="block text-sm font-medium text-gray-700 dark:text-zinc-100 mb-1"
        >
          Classification
        </label>
        <Dropdown
          id="classification"
          value={filters.classification || ""}
          onChange={handleClassificationChange}
          disabled={!categories && !categoriesWithGroups}
          placeholder="All Categories"
          options={categories}
          optionsWithGroups={categoriesWithGroups}
        />
      </div>
    </>
  );
}
